import React from 'react';
import PropTypes from 'prop-types';
import { ReactSVG } from 'react-svg';
import Button from 'common-ui-components/dist/components/Atoms/Button';
import './ShareCart.scss';

const ShareCart = ({ labels, shareCartIcon, handleShareCartButtonClick }) => {
  const { shareCart } = labels;
  const buttonProps = {
    className: 'utilityBorder',
    elementLocator: 'share-cart-button',
    onClick: () => handleShareCartButtonClick(),
  };

  return (
    <div className="share-cart-button">
      <Button {...buttonProps}>
        {shareCart}
        <ReactSVG wrapper="span" src={shareCartIcon} className="icon" />
      </Button>
    </div>
  );
};

ShareCart.propTypes = {
  labels: PropTypes.shape({ shareCart: PropTypes.string }),
  shareCartIcon: PropTypes.string,
  handleShareCartButtonClick: PropTypes.func,
};

ShareCart.defaultProps = {
  labels: {},
  shareCartIcon: '',
  handleShareCartButtonClick: () => {
    /* handle share cart button click event */
  },
};

export default ShareCart;
